import { CustomScrollbarTextarea } from "@smartsuite/react-ui/lib/components/forms/CustomScrollbarTextarea";
import { InputGroup } from "@smartsuite/react-ui/lib/components/forms/InputGroup";
import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph";
import { useInputGroupState } from "@smartsuite/react-ui/lib/hooks/useInputGroupState/useInputGroupState";
import { ErrorMessage, Field, type FieldInputProps, useFormikContext } from "formik";
import React, { useEffect } from "react";
import * as yup from "yup";
import { validateWithYup } from "../../registry/validator";
import { $t } from "../../utils/intl";
import { texts } from "./OtherOptionField.texts";

export const OTHER_OPTION_VALUE = "OTHER_VALUE";
const MAX_LENGTH = 50;

interface OtherOptionFieldProps {
  name: string;
  isReadOnly?: boolean;
}

export const OtherOptionField = ({ name, isReadOnly }: OtherOptionFieldProps): JSX.Element => {
  const {
    state: otherOptionState,
    onBlur: onBlurOtherOption,
    onFocus: onFocusOtherOption,
  } = useInputGroupState();

  const descriptionFieldName = `${name}.description`;

  const { setFieldValue, values, errors, touched } = useFormikContext<{
    [key: string]: {
      description: string;
    };
  }>();

  useEffect(() => {
    if (!values[name] || typeof values[name].description !== "string") {
      setFieldValue(descriptionFieldName, "");
    }
  }, [name]);

  const error = touched[name]?.description && errors[name]?.description;

  return (
    <>
      <InputGroup state={otherOptionState} inputBackground="white" className="other-option-field">
        <Field
          name={descriptionFieldName}
          id={descriptionFieldName}
          validate={validateWithYup(yup.string().required())}
        >
          {({ field }: { field: FieldInputProps<string> }) => (
            <CustomScrollbarTextarea
              name={descriptionFieldName}
              id={descriptionFieldName}
              minHeight={84}
              maxHeight={200}
              rows={3}
              gutterBottom={16}
              gutterTop={5}
              className={error ? "other-option-field__error" : ""}
              maxLength={MAX_LENGTH}
              translateContentSizeYToHolder={true}
              placeholder={$t(texts.otherOptionPlaceholder)}
              readOnly={isReadOnly}
              changeHeightWhenTyping={true}
              value={field.value}
              onBlur={(e) => {
                field.onBlur(e);
                onBlurOtherOption();
              }}
              onChange={field.onChange}
              onFocus={onFocusOtherOption}
            />
          )}
        </Field>
      </InputGroup>
      <ErrorMessage name={descriptionFieldName}>
        {() => (
          <Paragraph className="other-option-field__error-message" color="error" size="s">
            {$t(texts.required)}
          </Paragraph>
        )}
      </ErrorMessage>
    </>
  );
};
